var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customizer-external-includes-china-headers"
  }, [_c('div', {
    class: ['header-container', {
      'expanded': _vm.showHeaderContainer
    }, {
      'show-dropdown': _vm.showCountryDropdown
    }]
  }, [_c('div', {
    staticClass: "main-header-container vans-china"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseUrl
    }
  }, [_c('div', {
    staticClass: "brand-logo"
  })])]), _c('div', {
    staticClass: "upper-right-area"
  }, [_c('ul', {
    staticClass: "upper-right-bar"
  }, [_c('li', {
    staticClass: "country-bar",
    on: {
      "click": function click($event) {
        return _vm.clickCountryBar(true);
      }
    }
  }, [_c('a', {
    staticClass: "country-drop-trigger",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('svg', {
    attrs: {
      "width": "10px",
      "viewBox": "0 0 460 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#D0D0D0",
      "d": "M5 185.466l67.589-67.615 157.423 157.399 157.399-157.399 67.589 67.615-224.988 224.988z"
    }
  })]), _c('span', [_vm._v("位置")])]), _c('ul', {
    ref: "headerDropdown",
    class: ['country-dropdown', {
      'expanded': _vm.showCountryDropdown
    }],
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "focusout": _vm.focusoutCountryDropdown
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _vm._m(14), _vm._m(15), _vm._m(16), _vm._m(17), _vm._m(18), _vm._m(19), _vm._m(20), _vm._m(21), _vm._m(22), _vm._m(23), _vm._m(24), _vm._m(25), _vm._m(26), _vm._m(27), _vm._m(28), _vm._m(29), _vm._m(30)])]), _c('li', {
    staticClass: "contact-bar desktop-only"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/article-gongsi-1471.html")
    }
  }, [_c('span', [_vm._v("获取帮助")])])]), _c('li', {
    staticClass: "artwork-bar desktop-only"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/passport.html")
    }
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M251.089 474.366l-7.962-11.469c-32.793-47.483-72.599-82.455-107.666-113.258-59.141-51.938-110.131-96.767-110.131-180.171 0-32.983 12.7-63.975 35.826-87.195 23.221-23.41 54.212-36.3 87.384-36.3 23.884 0 46.915 6.824 66.628 19.714 14.311 9.383 26.443 21.609 35.731 35.826 22.462-34.215 61.32-55.539 103.307-55.539 67.955 0 123.21 55.444 123.21 123.494 0 36.489-10.71 68.144-33.74 99.611-20.093 27.58-47.388 51.748-76.296 77.433-37.627 33.457-76.579 67.955-108.614 116.102l-7.677 11.752zM148.066 95.827c-28.054 0-38.196 6.824-57.814 24.168-19.524 17.249-18.861 69.188-8.531 91.46 26.537 57.341 20.946 45.587 74.4 93.355 33.172 25.59 62.837 61.984 95.251 100.464 31.939-39.142 66.628-73.262 98.568-99.99 28.243-30.707 36.963-38.954 55.918-61.605 20.472-24.643 25.116-48.525 23.221-76.769-3.128-47.483-20.283-68.524-73.736-72.504-40.565-3.033-50.895 18.008-75.537 39.806l-28.433 35.067-25.116-29.381c-15.543-18.103-13.553-18.103-29.855-27.486-16.586-12.795-28.149-16.586-48.337-16.586z"
    }
  })]), _c('span', [_vm._v("我的作品")])])]), _c('li', {
    staticClass: "location-bar"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/exshop-search.html")
    }
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "viewBox": "0 0 792 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M736.97 366.932c0-201.956-153.6-366.932-341.334-366.932s-341.334 164.978-341.334 366.932v2.844c0 295.822 301.512 634.31 301.512 634.31 11.378 11.378 25.6 19.912 39.822 19.912v0c14.222 0 28.444-5.688 39.822-19.912 2.844-5.688 301.512-347.022 301.512-634.312v0-2.844zM395.636 512c-93.868 0-170.668-76.8-170.668-170.668s76.8-170.668 170.668-170.668 170.666 76.8 170.666 170.668-76.8 170.668-170.668 170.668z"
    }
  })]), _c('span', [_vm._v("STORE")])])]), _c('li', {
    staticClass: "cart-bar"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/cart.html")
    }
  }, [_c('svg', {
    attrs: {
      "width": "30px",
      "viewBox": "0 0 1114 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.732 46.289h222.66l84.675 247.749h765.208l-112.901 470.415h-589.586l-228.937-624.082-141.126 3.135v-97.217zM459.784 667.236h445.325l59.586-275.974h-598.993l94.082 275.974zM453.513 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811s87.811-37.632 87.811-87.811c3.135-50.179-37.632-87.811-87.811-87.811zM864.343 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811 50.179 0 87.811-37.632 87.811-87.811s-37.632-87.811-87.811-87.811z"
    }
  })]), _c('span', [_vm._v("我的购物车")])])]), _c('li', {
    staticClass: "account-bar"
  }, [_c('a', {
    staticClass: "desktop-only",
    attrs: {
      "href": "".concat(_vm.baseUrl, "/passport-signup.html")
    }
  }, [_c('span', [_vm._v(" / 注册")])]), _c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/passport-login.html")
    }
  }, [_c('svg', {
    attrs: {
      "width": "30",
      "viewBox": "0 0 458 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.947 495.832c0-45.81 0-86.231 0-133.389 55.242-25.6 110.484-51.2 168.421-78.147-14.821-43.116-32.337-80.842-41.769-121.263-10.779-47.158-12.126-99.706 40.421-122.611 28.294-12.127 71.411-12.127 99.706 1.347 49.853 24.252 49.853 76.8 37.726 123.958-9.432 39.073-26.947 74.106-43.116 117.221 56.589 26.947 114.526 53.894 171.116 79.495 0 47.158 0 87.579 0 132.042-145.516 1.348-288.337 1.348-432.505 1.348z"
    }
  })]), _c('span', [_vm._v(" 登录 ")])])]), _c('li', {
    staticClass: "menu-bar",
    on: {
      "click": function click($event) {
        return _vm.clickMenuBar();
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('svg', {
    attrs: {
      "width": "30",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32 96h448v96h-448zM32 224h448v96h-448zM32 352h448v96h-448z"
    }
  })])])])])]), _c('div', {
    class: ['nav-bar', {
      'expanded': _vm.showNavBar
    }]
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_vm._m(31), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/article-vans-l-30.html")
    }
  }, [_vm._v("关于 "), _c('b', [_vm._v("VANS")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/article-artist-sl-23-local.html")
    }
  }, [_vm._v("运动员")])]), _vm._m(32), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/customs.html")
    }
  }, [_c('b', [_vm._v("CUSTOMS")])])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/gallery-index---0---11.html")
    }
  }, [_vm._v("新品上线")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/gallery-index---0---36.html")
    }
  }, [_vm._v("男子")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/gallery-index---0---37.html")
    }
  }, [_vm._v("女子")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/exshop-search.html")
    }
  }, [_vm._v("搜索店铺")])])])]), _c('div', {
    class: ['hide-header', {
      'expanded': _vm.showHideHeader
    }],
    on: {
      "click": function click($event) {
        return _vm.clickHideHeader();
      }
    }
  }, [_c('div', {
    staticClass: "hide-indicator"
  }, [_c('svg', {
    attrs: {
      "width": "15px",
      "viewBox": "0 0 460 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M229.978 381.202l225.449-250.266h-450.897l225.447 250.266z"
    }
  })])])])])]), _c('div', {
    staticClass: "gtm-sidebar-livechat",
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "right": "0",
      "transform": "translateY(-50%)",
      "z-index": "50"
    }
  }, [_c('a', {
    attrs: {
      "target": "_parent",
      "href": "http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=772724&configID=150737&jid=9415958668"
    }
  }, [_c('button', {
    staticStyle: {
      "background": "#AA292D",
      "height": "35px",
      "width": "35px",
      "outline": "none",
      "border": "none",
      "cursor": "pointer",
      "padding": "0"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "35px",
      "height": "35px",
      "viewBox": "30.6 120.6 550.8 550.8"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M405.144,254.016H206.856c-24.48,0-42.84,18.36-42.84,42.84v127.296c0,24.479,18.36,42.84,42.84,42.84\n            v70.992l110.16-70.992h88.128c24.48,0,42.841-18.36,42.841-42.84V296.856C447.984,272.376,429.624,254.016,405.144,254.016z\n             M419.832,424.152c0,8.567-6.12,14.688-14.688,14.688h-96.695l-73.44,46.512V438.84h-28.152c-8.568,0-14.688-6.12-14.688-14.688\n            V296.856c0-8.568,6.12-14.688,14.688-14.688h198.288c8.568,0,14.688,6.12,14.688,14.688V424.152z"
    }
  })])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vans.com.cn/"
    }
  }, [_c('span', [_vm._v("中国")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.hk/en/"
    }
  }, [_c('span', [_vm._v("Hong Kong SAR")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.hk/"
    }
  }, [_c('span', [_vm._v("香港特別行政區")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.kr/"
    }
  }, [_c('span', [_vm._v("대한민국")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.sg/"
    }
  }, [_c('span', [_vm._v("Singapore")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.in/"
    }
  }, [_c('span', [_vm._v("India")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.my/"
    }
  }, [_c('span', [_vm._v("Malaysia")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com/shop.html"
    }
  }, [_c('span', [_vm._v("USA")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ca/en_ca/homepage.html"
    }
  }, [_c('span', [_vm._v("Canada (English)")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ca/fr_ca/homepage.html"
    }
  }, [_c('span', [_vm._v("Canada (Français) ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.mx/es_mx/homepage.html"
    }
  }, [_c('span', [_vm._v("Méjico (Español) ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vansdobrasil.com/"
    }
  }, [_c('span', [_vm._v("Brasil ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vansargentina.com/"
    }
  }, [_c('span', [_vm._v("Argentina ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.at/"
    }
  }, [_c('span', [_vm._v("Österreich ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.fr/"
    }
  }, [_c('span', [_vm._v("France ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.de/"
    }
  }, [_c('span', [_vm._v("Deutschland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ie/"
    }
  }, [_c('span', [_vm._v("Ireland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Israel ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.it/"
    }
  }, [_c('span', [_vm._v("Italia ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.nl/"
    }
  }, [_c('span', [_vm._v("Nederland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Polska ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.pt/"
    }
  }, [_c('span', [_vm._v("Portugal ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vans.ru/"
    }
  }, [_c('span', [_vm._v("Россия ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.es/"
    }
  }, [_c('span', [_vm._v("España ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.se/"
    }
  }, [_c('span', [_vm._v("Sweden ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Switzerland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Türkiye ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.uk/"
    }
  }, [_c('span', [_vm._v("United Kingdom ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vansjapan.com/"
    }
  }, [_c('span', [_vm._v("日本 ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.net.au/"
    }
  }, [_c('span', [_vm._v("Australia ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.nz/"
    }
  }, [_c('span', [_vm._v("New Zealand ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "mobile-only"
  }, [_c('a', {
    attrs: {
      "href": "http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=772724&configID=150737&jid=9415958668"
    }
  }, [_c('b', [_vm._v("LIVE CHAT")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "https://houseofvansasia.com.cn/musicianswanted/zh-cn"
    }
  }, [_c('b', [_vm._v("HOUSE OF VANS")])])]);
}]

export { render, staticRenderFns }